import type { HlmDatePickerConfig } from "./date-picker/src/lib/hlm-date-picker.token";
import type { HlmDateRangePickerConfig } from "./date-picker/src/lib/hlm-date-range-picker.token";

/**
 * Formats a date as dd/MM/yyyy (Italian format)
 */
const formatDateItalian = (date: Date): string => {
  if (!date) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Default date picker configuration for O2 application
 * Format: dd/MM/yyyy (Italian format)
 * Auto-close on select: true
 */
export const O2_DATE_PICKER_CONFIG: Partial<HlmDatePickerConfig<Date>> = {
  autoCloseOnSelect: true,
  formatDate: formatDateItalian,
  transformDate: (date: Date) => date,
};

/**
 * Default date range picker configuration for O2 application
 * Format: dd/MM/yyyy - dd/MM/yyyy (Italian format)
 * Auto-close on end selection: true
 */
export const O2_DATE_RANGE_PICKER_CONFIG: Partial<HlmDateRangePickerConfig<Date>> = {
  autoCloseOnEndSelection: true,
  formatDates: (dates) =>
    dates
      .filter(Boolean)
      .map((date) => (date instanceof Date ? formatDateItalian(date) : String(date)))
      .join(" - "),
  transformDates: (dates) => dates,
};
